export default "__VITE_ASSET__BDGTjBRt__"